import { render, staticRenderFns } from "./PointerIcon.vue?vue&type=template&id=2cdd6991&"
import script from "./PointerIcon.vue?vue&type=script&lang=js&"
export * from "./PointerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports